import { useCallback, useEffect, useLayoutEffect, useState } from 'react';

const OVERFLOW_TOLERANCE_PX = 1;

const isClippedByItsBox = (element: HTMLElement) =>
  element.scrollHeight - element.clientHeight > OVERFLOW_TOLERANCE_PX ||
  element.scrollWidth - element.clientWidth > OVERFLOW_TOLERANCE_PX;

export const useIsTextTruncated = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const measure = useCallback(() => {
    if (!element) return;
    setIsTruncated(isClippedByItsBox(element));
  }, [element]);

  useLayoutEffect(measure);

  useEffect(() => {
    if (!element || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, measure]);

  useEffect(() => {
    if (!element || !document.fonts) return;
    let isMounted = true;
    document.fonts.ready.then(() => {
      if (isMounted) measure();
    });
    return () => {
      isMounted = false;
    };
  }, [element, measure]);

  return { ref: setElement, isTruncated };
};
